import React, { useState, useMemo } from 'react';
import GalaIcon from 'src/GalaIcon';
import { IAllDrawingEntry } from 'src/types';

const UserWins: React.FC<{
  allWinningDraws: IAllDrawingEntry[],
  drawId: number,
}> = ({ allWinningDraws, drawId }) => {

  const [visibleCount, setVisibleCount] = useState<number>(5);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 5); // Load 5 more rows
  };

  const filteredEntries = useMemo(() => {
    return allWinningDraws.filter(i => i.rewardAmount > 0);
  },[allWinningDraws])
    
  return (
    <section className="winning-draws w-full pb-6">
        {/* <h3 className='text-xl font-bold text-white text-left flex flex-row flex-nowrap items-center justify-start gap-2'>
            Draw {drawId}
            <span className='text-sm text-lottoblue-400'>{endDate.toLocaleDateString()}</span>
        </h3> */}
            <div className="pt-4 overflow-x-auto w-full pb-4">
                {filteredEntries.length > 0 ? (
                    <table className="animation-fade mt-2 w-full min-w-96 text-sm text-left text-lottoblue-400 border-spacing-4 border-0">
                        <thead className='border-0 sr-only'>
                        <tr>
                            <th className="font-bold text-center text-sm p-2 text-lottoblue-600 bg-lottoblue-700 border-r-8 border-[#020025]">Ticket</th>
                            <th className="font-bold text-center text-sm p-2 text-lottoblue-600 bg-lottoblue-700 relative">
                                Chosen Numbers
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {[...filteredEntries].slice(0, visibleCount).map((draw, index) => (
                            <tr key={index} className={`${index < [...filteredEntries].slice(0, visibleCount).length - 1 ? 'border-b border-lottoblue-700': ''}`}>
                                <td className="py-4 text-center">
                                    <div className='leading-none rounded-full px-5 py-2 font-bold text-lottoblue-900 bg-lottogreen flex items-center justify-between gap-1 flex-nowrap flex-1'>
                                        <span className='text-lottoblue-600'>Draw #{drawId}</span> 
                                        <span className='flex flex-row flex-nowrap items-center justify-start gap-1'>WIN <GalaIcon className='w-6 h-6'/> {draw.rewardAmount}</span>
                                    </div>
                                </td>
                                <td className="py-4 text-center">
                                    <div className="ml-auto max-w-[196px] flex flex-row flex-wrap flex-1 items-center justify-start gap-1 px-4">
                                        { draw.numbers.sort((a, b) => a - b).map((number, index) => (
                                            <span key={index} className='flex items-center justify-center rounded-full w-8 h-8 text-white bg-lottoblue-700'>{number}</span>
                                        ))
                                        }
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                 ) : (
                <p className="text-lottoblue-600 italic w-full text-center py-2">No Winning Results Currently</p>
                 )}
            </div>

            {visibleCount < filteredEntries.length && (
                <div className="w-full flex items-center justify-center mt-4">
                    <button onClick={handleLoadMore} className="text-xs uppercase font-bold bg-transparent border border-lottoblue-600 text-lottoblue-400 px-6 py-1 rounded-full">
                        Load More
                    </button>
                </div>
            )}
    </section>
  );
};

export default UserWins;